import React from "react";
import './Footer.css';

export default function Links(props) {
    return <div class="links">


        {/*Link icons on the footer (e.g. instagram) are set here.*/}
        {/* Icons are 512x512px images */}
        {/* ////////////////////////////////////////////////////////////////////////////////////// */}
        <a href="mailto:ewb-execs@wpi.edu" target="blank"><img src="footer_links/email.png" /></a>
        <a href="https://www.instagram.com/ewb.wpi/" target="blank"><img src="footer_links/instagram.png" /></a>
        <a href="https://www.facebook.com/ewbusawpi/" target="blank"><img src="footer_links/facebook.png" /></a>
        <a href="https://www.linkedin.com/company/wpi-ewb-usa/posts/?feedView=all" target="blank"><img src="footer_links/linkedin.png" /></a>
        <a href="https://mywpi.wpi.edu/EWB/club_signup" target="blank"><img src="footer_links/mywpi.png" /></a>
        <a href="https://join.slack.com/t/ewb-usa-wpi/shared_invite/zt-3buuz02is-UwGGlNYwsfOUpmzo2KsJCA" target="blank"><img src="footer_links/slack.png" /></a>
        {/* ////////////////////////////////////////////////////////////////////////////////////// */}


    </div>
}